/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Funnel_Ob_Recap_EyebrowInputs */

const en_funnel_ob_recap_eyebrow = /** @type {(inputs: Funnel_Ob_Recap_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Almost there`)
};

const es_funnel_ob_recap_eyebrow = /** @type {(inputs: Funnel_Ob_Recap_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ya casi está`)
};

/**
* | output |
* | --- |
* | "Almost there" |
*
* @param {Funnel_Ob_Recap_EyebrowInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const funnel_ob_recap_eyebrow = /** @type {((inputs?: Funnel_Ob_Recap_EyebrowInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Funnel_Ob_Recap_EyebrowInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_funnel_ob_recap_eyebrow(inputs)
	return en_funnel_ob_recap_eyebrow(inputs)
});